import { render, staticRenderFns } from "./TagStatistical.vue?vue&type=template&id=9acce836&scoped=true"
import script from "./TagStatistical.vue?vue&type=script&lang=js"
export * from "./TagStatistical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acce836",
  null
  
)

export default component.exports